import React from 'react';
import PropTypes from 'prop-types';

import PasswordInput from './PasswordInput';
import { PASSWORD_ERROR } from '../utils/password';


class PasswordField extends React.Component {
    render() {
        const c = this;
        const { path, label, autoComplete, fullWidth } = c.props;
        const { controller } = c.context;
        const model = controller.getModel(path);

        if (model.is('hidden')) {
            return null;
        }

        const editable = controller.isEditable() && !model.is('readonly');
        const valid = model.isValid() || (!model.isDirty() && !controller.state.submitted);

        return <PasswordInput
            label={label}
            value={model.getViewValue() || ''}
            onChange={e => controller.valueChanged(path, e.target.value)}
            error={!valid}
            disabled={!editable}
            fullWidth={fullWidth}
            autoComplete={autoComplete}
            helperText={!valid ? PASSWORD_ERROR : ''}
        />;
    }
}

PasswordField.propTypes = {
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    autoComplete: PropTypes.string,
    fullWidth: PropTypes.bool
};

PasswordField.defaultProps = {
    autoComplete: 'new-password',
    fullWidth: true
};

PasswordField.contextTypes = {
    controller: PropTypes.object
};

export default PasswordField;
